import { IListViewField } from "src/components/Shared/ILIstViewField";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";
import { AppEntities } from "src/config/entities";

const BankOpeningBalancesList = () => {
  const fields: IListViewField[] = [
    {
      title: "Company",
      fieldType: "string",
      fieldName: "companyName"
    },
    {
      title: "Comment",
      fieldType: "string",
      fieldName: "comment"
    }
  ];

  return (
    <>
      <ListView fields={fields} entity={AppEntities.BankOpeningBalances} createMoreActions={[]}>
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>{" "}
    </>
  );
};

export default BankOpeningBalancesList;
